import * as React from 'react';
import { Hero } from '@brightlayer-ui/react-components/core';
import { Data, isDataLoading, isDataLoaded } from '../../types/data-providers';
import { getIcon } from '../../lib/icons';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { getStatusIcon, getStatusIconColor } from '../../data/domain/metric-data-helpers';
import { OnlineStatus } from '../../types';

type OnlineStatusData = Data<any | undefined>;

const getOnlineData = (
    onlineStatusData: OnlineStatusData
): {
    value: OnlineStatus;
} => {
    if (isDataLoading(onlineStatusData)) {
        return {
            value: OnlineStatus.Pending,
        };
    }

    if (!isDataLoaded(onlineStatusData)) {
        return {
            value: OnlineStatus.Unknown,
        };
    }

    if (onlineStatusData.value && onlineStatusData.value.status) {
        return {
            value: OnlineStatus.Online,
        };
    }

    return {
        value: OnlineStatus.Offline,
    };
};

const getStatusText = (value: OnlineStatus): string => {
    switch (value) {
        case OnlineStatus.Online:
            return 'DASHBOARD.SITE_DETAILS.READING_CARDS.ONLINE';
        case OnlineStatus.Pending:
            return 'DASHBOARD.SITE_DETAILS.READING_CARDS.PENDING';
        case OnlineStatus.Unknown:
            return 'DASHBOARD.SITE_DETAILS.READING_CARDS.PENDING';
        default:
            return 'DASHBOARD.SITE_DETAILS.READING_CARDS.OFFLINE';
    }
};

export const ConnectionHero: React.FC<{ onlineStatusData: OnlineStatusData; testId?: string }> = (props) => {
    const onlineData = getOnlineData(props.onlineStatusData);
    const TheIcon = getIcon(getStatusIcon(onlineData.value));
    const { t } = useLanguageLocale();
    const label = t('DEVICE_DETAILS.STATUS');

    return (
        <div data-testid={props.testId} style={{ minWidth: 0 }} title={label}>
            <Hero
                icon={<TheIcon fontSize="large" style={{ color: getStatusIconColor(onlineData.value) }} />}
                label={label}
                ChannelValueProps={{ value: t(getStatusText(onlineData.value)) }}
                iconSize="small"
                sx={{
                    '& .BluiHero-label': {
                        whiteSpace: 'normal !important',
                        overflow: 'visible !important',
                        textOverflow: 'clip !important',
                        wordBreak: 'break-word',
                        lineHeight: 1.15,
                        fontSize: '0.875rem',
                    },
                }}
            />
        </div>
    );
};
